import angular from 'angular'
import quickTimePicker from './quickTimePicker.component'

export default angular
  .module('ellipsis.quickTimePicker', [])
  .component('quickTimePicker', quickTimePicker)
